<template>
    <div style="padding: 20px 0;">
        <div style="font-size: 20px;padding: 0 20px;" class="jcsb">
            <div>查看下发门店</div>
        </div>
        <div style="margin-top: 40px; padding: 0 20px;">
            <p style="margin-bottom: 15px">已下发的门店如下：</p>
            <Table :columns="columns" :data="mendians" border></Table>
            <div style="margin-top: 20px;padding:0;display: flex;align-items: center;">
                <Input search style="width: 200px;margin-right: 20px;" size="small" placeholder="搜索" v-model="query.keywords" @on-enter="keywordsChanged"></Input>
                <Page placement="top" :page-size-opts="[10,20,50,100,200]" :total="total" :current="page.current" :page-size="page.size" @on-change="pageChanged" @on-page-size-change="pageSizeChanged" show-sizer show-total size="small"></Page>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: String,
            dataId: String,
        },
        data() {
            return {
                query: {
                    keywords: "",
                    sort: null,
                    init: true,
                },
                total: 0,
                page: {
                    size: 10,
                    current: 1
                },
                mendians: [],
                columns: [
                    { title: '商户号', key: 'code' },
                    { title: '门店名称', key: 'name' }
                ]
            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            async loadData() {
                this.loading = true
                let res = await this.$api.post('/web/main/keyongmendians/load', {
                    query: this.query,
                    type: this.type,
                    dataId: this.dataId,
                    fields: {
                        "name": 1,
                        "code": 1,
                        "level": 1,
                        "parent": 1,
                        "parentStr": 1,
                        "relations": 1,
                        "type": 1,
                    },
                    page: this.page
                })
                this.loading = false
                if (res.data.mendians) {
                    this.mendians = res.data.mendians
                    this.total = res.data.total
                }
            },
            pageSizeChanged(value) {
                this.page.size = value
                // sessionStorage.pagesize = value
                if (this.page.current == 1) this.loadData()
            },
            pageChanged(value) {
                this.page.current = value
                this.loadData()
            },
            keywordsChanged() {
                this.usedKeywords = this.query.keywords
                this.page.current = 1
                this.loadData()
            },
            sortChanged() {
                this.page.current = 1
                this.loadData()
            },
        }
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/common/XiafaMendianView.vue?539a230e